'use strict';
const RequestConfigurationManager = require('./request-configuration-manager')
const AuthenticationManager = require('./authentication-manager');

class RequestManager {
  constructor(sdkConfiguration, request, credentials) {
    this.requestConfigurationManager = new RequestConfigurationManager(sdkConfiguration, request, credentials);
    this.authConfiguration = new RequestConfigurationManager(sdkConfiguration, request, credentials);
    this.authenticationManager = new AuthenticationManager(this.authConfiguration);
  }

  makeRequest(requestParams) {
    return this.authenticationManager.tokenRefresh().then((accessToken) => {
      this.requestConfigurationManager.setAuthorizationHeader(accessToken);
      return this.requestConfigurationManager.request(this.requestConfigurationManager.getOptions(requestParams));        
    });
  }


}

module.exports = RequestManager;
